import Vue from 'vue';
import { utcToZonedTime, format } from 'date-fns-tz';
import {
  parse,
  isToday,
  isYesterday,
  isThisWeek,
  formatDistance,
} from "date-fns";
import parseISO from 'date-fns/parseISO';
import { enUS as en, es, ja } from "date-fns/locale";
import i18n from './i18n';

const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const modules = { en, es, ja };
let locale = modules[localStorage.getItem("languageSelect") || "en"] || en;

Vue.filter('toDate', (value, strFormat) => {
  if (!value) return '';
  let date = value;
  if (!(date instanceof Date)) { date = value.toDate(); }
  return format(date, strFormat, { locale });
});

Vue.filter('zonedDate', (value, strFormat, timezone, force = false) => {
  if (!value) return '';
  let date = value;
  if (!(date instanceof Date)) { date = value.toDate(); }
  if (date.getTime() === 0 && !force) { return 'No Date'; }
  const zonedDate = utcToZonedTime(date, timezone || currentTimeZone);
  return format(zonedDate, strFormat, { locale });
});

Vue.filter('strToDate', (value, strFormat) => {
  if (!value) return '';
  return format(parseISO(value), strFormat, { locale });
});

Vue.filter('parseLocale', (value, strFormat) => {
  if (!value) return '';
  console.log('parsing', value, strFormat);
  return parse(value, strFormat, new Date(), { locale });
});

Vue.filter('smartDate', (value) => {
  if (isToday(value)) {
    return format(value, "p", { locale });
  } if (isYesterday(value)) {
    return i18n.t('common.time.yesterday');
  } if (isThisWeek(value)) {
    return format(value, "EEEE", { locale });
  }
  return format(value, "PP", { locale });
});

Vue.filter("timeDistanceFromNow", (date, now) => formatDistance(date, now || (new Date()), { locale }));

const updateLocale = (newLocale) => {
  locale = modules[newLocale || "en"] || en;
};

export default {
  updateLocale,
};
